import { render } from "./B2CQuickViewChart.vue?vue&type=template&id=d95f66c6&scoped=true&lang=pug"
import script from "./B2CQuickViewChart.vue?vue&type=script&setup=true&lang=js"
export * from "./B2CQuickViewChart.vue?vue&type=script&setup=true&lang=js"

import "./B2CQuickViewChart.vue?vue&type=style&index=0&id=d95f66c6&lang=sass&scoped=true"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d95f66c6"]])

export default __exports__